import { render, staticRenderFns } from "./TopSection.vue?vue&type=template&id=0802a89f&scoped=true&"
import script from "./TopSection.vue?vue&type=script&lang=js&"
export * from "./TopSection.vue?vue&type=script&lang=js&"
import style0 from "./TopSection.vue?vue&type=style&index=0&id=0802a89f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0802a89f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSheet})
